import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';

// PrimeNG Modules
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { ChipModule } from 'primeng/chip';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';

// Components
import { HelpTutorialsComponent } from './help-tutorials.component';
import { FloatingHelpButtonComponent } from './components/floating-help-button/floating-help-button.component';
import { HelpSidebarComponent } from './components/help-sidebar/help-sidebar.component';
import { StepViewerComponent } from './components/step-viewer/step-viewer.component';
import { TutorialFormDialogComponent } from './components/tutorial-form-dialog/tutorial-form-dialog.component';
import { StepFormDialogComponent } from './components/step-form-dialog/step-form-dialog.component';

// Pipes
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { HighlightPipe } from './pipes/highlight.pipe';

/**
 * Help Tutorials Module
 * Self-contained, portable feature module.
 * 
 *
 * Note: TutorialService uses providedIn: 'root', so no need to list in providers.
 * Note: HttpClient is expected to be provided by the consuming app's root module.
 */
@NgModule({
  declarations: [
    HelpTutorialsComponent,
    FloatingHelpButtonComponent,
    HelpSidebarComponent,
    StepViewerComponent,
    TutorialFormDialogComponent,
    StepFormDialogComponent,
    SafeHtmlPipe,
    HighlightPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    A11yModule,
    DragDropModule,
    InputTextModule,
    ButtonModule,
    ChipModule,
    DialogModule,
    EditorModule
  ],
  exports: [
    HelpTutorialsComponent
  ]
})
export class HelpTutorialsModule { }
